export default __webpack_public_path__ + "static/media/lamb.d4ce26fe.jpg";